import { gql } from '@apollo/client';

// Create Complete Shipment Mutation
export const CREATE_COMPLETE_SHIPMENT_MUTATION = gql`
  mutation CreateCompleteShipment($input: CreateCompleteShipmentInput!) {
    createCompleteShipment(input: $input) {
      shipment {
        manifest
        reference
        in_transit
        driver
        driver_phone
        notes
        created_at
        origin {
          id
          origin_name
        }
        destination {
          id
          destination_name
        }
        loggedUser {
          id
          full_name
        }
      }
      details {
        bill_of_lading
        commercial_invoice
        consignee {
          id
          full_name
        }
        suppliers {
          id
          supplier_name
          email
        }
        ffUser {
          id
          full_name
        }
        sellerUser {
          id
          full_name
        }
      }
      initialEvent {
        id
        status_detail
        status_date
        approved
        created_at
      }
    }
  }
`;

// Authentication Mutations
export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      token
      refreshToken
      message
      user {
        id
        email
        full_name
        is_active
        role {
          id
          role_name
        }
      }
    }
  }
`;

export const REGISTER_MUTATION = gql`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      token
      refreshToken
      message
      user {
        id
        email
        full_name
        is_active
        role {
          id
          role_name
        }
      }
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      success
      message
    }
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input)
  }
`;

// Shipment Mutations
export const CREATE_SHIPMENT_EVENT_MUTATION = gql`
  mutation CreateShipmentEvent($input: CreateShipmentEventInput!) {
    createShipmentEvent(input: $input) {
      id
      manifest
      status_detail
      status_date
      approved
      created_at
    }
  }
`;

export const APPROVE_AND_UPDATE_EVENT_MUTATION = gql`
  mutation ApproveAndUpdateEvent(
    $id: UUID!
    $statusDetail: String!
    $selectedRecipientsByGroup: [SelectedRecipientsGroupInput!]!
  ) {
    approveAndUpdateEvent(
      id: $id
      statusDetail: $statusDetail
      selectedRecipientsByGroup: $selectedRecipientsByGroup
    ) {
      id
      manifest
      status_detail
      approved
      created_at
    }
  }
`;

export const COMPLETE_SHIPMENT_MUTATION = gql`
  mutation CompleteShipment($input: CompleteShipmentInput!) {
    completeShipment(input: $input) {
      id
      manifest
      status_detail
      status_date
      approved
      created_at
    }
  }
`;

export const DELETE_SHIPMENT_EVENT_MUTATION = gql`
  mutation DeleteShipmentEvent($id: UUID!) {
    deleteShipmentEvent(id: $id)
  }
`;

// Update Complete Manifest Mutation
export const UPDATE_COMPLETE_MANIFEST_MUTATION = gql`
  mutation UpdateCompleteManifest($input: UpdateCompleteManifestInput!) {
    updateCompleteManifest(input: $input) {
      manifest
      reference
      in_transit
      driver
      driver_passport
      driver_license
      driver_phone
      notes
      created_at
      origin {
        id
        origin_name
      }
      destination {
        id
        destination_name
      }
      loggedUser {
        id
        full_name
      }
    }
  }
`;

// Delete Complete Manifest Mutation
export const DELETE_COMPLETE_MANIFEST_MUTATION = gql`
  mutation DeleteCompleteManifest($manifest: String!) {
    deleteCompleteManifest(manifest: $manifest)
  }
`;